import { type IConfig } from '@cian/config/shared';
import { makeContextModule } from '@cian/react-utils';

import { type NonEmptyArray, type TJsonQuery } from '@/packages/JsonQuery';

import { type TApplyFiltersSource } from '../types/applyFiltersSource';
import { type TFilter, type TOpenedFiltersState } from '../types/filters';
import { type IGeoTagsMap } from '../types/geoTags';
import { type IHighwayDirection } from '../types/highways';
import { type TCurrentLocation } from '../types/location';
import { type TModifier } from '../types/modifier';
import { type ISpecialPromo } from '../types/specialPromo';

export interface IContext {
  config: IConfig;
  currentLocation: TCurrentLocation;
  highways: IHighwayDirection[];
  jsonQuery: TJsonQuery;
  jsonQueryCount: number;
  jsonQueryCountRefreshing: boolean;
  queryString: string | undefined;
  geoTags: IGeoTagsMap;
  isTooltipAvailable: boolean;
  lastAppliedModifiers: NonEmptyArray<TModifier> | null;
  openedFilters: TOpenedFiltersState;
  specialPromo: ISpecialPromo | null;
  isProfessionalSearchButtonVisible: boolean;
  villageName: string | null;

  openFilter(filter: TFilter): void;
  closeFilter(filter: TFilter): void;
  onApply(): void;
  onApplyOpenableFilter(...modifiers: NonEmptyArray<TModifier>): void;
  onApplyClick?(source: TApplyFiltersSource): void;
  onChange(...modifiers: NonEmptyArray<TModifier>): void;
  onClear?(): void;
  onGeoPopupOpen?(): void;
  onUndergroundPopupOpen?(): void;
  onDistrictPopupOpen?(): void;
  onHighwaysPopupOpen?(): void;
  onRegionalDistrictsOpen?(): void;
}

export const {
  useContext: useFiltersContext,
  Context: { Provider: FiltersContextProvider },
} = makeContextModule<IContext>({
  contextName: 'FiltersContext',
});
